import awsConfigDefault from "./aws-config";

const awsConfigLocal = null //TODO figure out how to load this
const serviceConfig = awsConfigLocal || awsConfigDefault;

export default serviceConfig;
